var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPmGiftcard = function SvgPmGiftcard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 6.75,
    width: 32.5,
    height: 20.5,
    rx: 3.25,
    fill: "#E8F0FF",
    stroke: "#1769FF",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 13.89V24m0-10.11c-.281-1.16-.766-2.151-1.39-2.845-.624-.694-1.36-1.058-2.11-1.045a1.944 1.944 0 0 0 0 3.89m3.5 0c.281-1.16.766-2.151 1.39-2.845.625-.694 1.36-1.058 2.11-1.045a1.944 1.944 0 0 1 0 3.89M22.445 17v5.445A1.556 1.556 0 0 1 20.889 24h-7.778a1.555 1.555 0 0 1-1.555-1.555V17m-.778-3.11h12.444c.43 0 .778.347.778.777v1.556c0 .43-.348.777-.778.777H10.778a.778.778 0 0 1-.778-.777v-1.556c0-.43.348-.778.778-.778Z",
    stroke: "#1769FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgPmGiftcard;